export * from './extract-of-points.page'
